import React, { useState } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { useHistory } from 'react-router';
import { Fragment } from 'react';
import TorontoFooter from '../../Layout/TorontoFooter';
import FullImageModal from './FullImageModal';
import graphic1 from '../../../images/mediakit/autzu-graphics1.svg';
import graphic2 from '../../../images/mediakit/autzu-graphics2.svg';
import graphic3 from '../../../images/mediakit/autzu-graphics3.svg';
import graphic4 from '../../../images/mediakit/autzu-graphics4.svg';
import graphic5 from '../../../images/mediakit/autzu-graphics5.svg';
import graphic6 from '../../../images/mediakit/autzu-graphics6.svg';
import graphic7 from '../../../images/mediakit/autzu-graphics7.svg';
import graphic8 from '../../../images/mediakit/autzu-graphics8.svg';
import graphic9 from '../../../images/mediakit/autzu-graphics9.svg';
import graphic10 from '../../../images/mediakit/autzu-graphics10.svg';
import renders1 from '../../../images/mediakit/autzu-renders1.svg';
import renders2 from '../../../images/mediakit/autzu-renders2.svg';
import renders3 from '../../../images/mediakit/autzu-renders3.svg';
import renders4 from '../../../images/mediakit/autzu-renders4.svg';

const MediaKit = () => {
  const history = useHistory();
  const [isFull, setIsFull] = useState();
  const [imgUrl, setImgUrl] = useState();

  const toggleImg = () => {
    // e.preventDefault();
    setIsFull(!isFull);
    document.addEventListener('click', closeImg);
  };

  const closeImg = () => {
    setIsFull(false);
    document.removeEventListener('click', closeImg);
  };

  return (
    <Fragment>
      <div className="resourcePageNarrow container">
        <div className="backToNewsroom">
          <FontAwesomeIcon
            className="backButton"
            icon={faArrowLeft}
            onClick={evt => {
              history.push('/newsroom');
              evt.stopPropagation();
            }}
          />
          <div
            onClick={() => {
              history.push('/newsroom');
            }}>
            Newsroom
          </div>
        </div>
        <div className="resourceTitleWithButton">
          Media kit
          <a
            href="https://drive.google.com/drive/folders/12EU387245fMSZ3AjcQe0YrWUZFCJtwNq?usp=sharing"
            target="_blank">
            <button style={{ margin: 0, cursor: 'pointer' }}>
              Download
            </button>
          </a>
        </div>
        <div className="whatsInclude">What's included</div>
        <div className="kitSection">
          <div className="sectionName">Logos</div>
          <div className="sectionImages">
            <img
              src={
                'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/logos/autzu-logo1.png'
              }
              onClick={() => {
                toggleImg();
                setImgUrl(
                  'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/logos/autzu-logo1.png'
                );
              }}></img>
            <img
              src={
                'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/logos/autzu-logo2.png'
              }
              onClick={() => {
                toggleImg();
                setImgUrl(
                  'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/logos/autzu-logo2.png'
                );
              }}
              style={{ border: '1px solid #dedede' }}></img>
            <img
              src={
                'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/logos/autzu-logo3-small.png'
              }
              onClick={() => {
                toggleImg();
                setImgUrl(
                  'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/logos/autzu-logo3.png'
                );
              }}></img>
            <img
              src={
                'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/logos/autzu-logo4-small.png'
              }
              onClick={() => {
                toggleImg();
                setImgUrl(
                  'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/logos/autzu-logo4.png'
                );
              }}></img>
          </div>
        </div>
        <div className="kitSection">
          <div className="sectionName">Uber Partnership</div>
          <div className="sectionImages">
            <img
              src={
                'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/uber-partnership/autzu-uber1.png'
              }
              onClick={() => {
                toggleImg();
                setImgUrl(
                  'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/uber-partnership/autzu-uber1.png'
                );
              }}></img>
            <img
              src={
                'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/uber-partnership/autzu-uber2.png'
              }
              onClick={() => {
                toggleImg();
                setImgUrl(
                  'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/uber-partnership/autzu-uber2.png'
                );
              }}
              style={{ border: '1px solid #dedede' }}></img>
            <img
              src={
                'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/uber-partnership/autzu-uber3-small.png'
              }
              onClick={() => {
                toggleImg();
                setImgUrl(
                  'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/uber-partnership/autzu-uber3.png'
                );
              }}></img>
            <img
              src={
                'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/uber-partnership/autzu-uber4-small.png'
              }
              onClick={() => {
                toggleImg();
                setImgUrl(
                  'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/uber-partnership/autzu-uber4.png'
                );
              }}></img>
          </div>
        </div>
        <div className="kitSection">
          <div className="sectionName">Color Palette</div>
          <div className="sectionImages">
            <img
              src={
                'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/colors/autzu-color1.png'
              }
              onClick={() => {
                toggleImg();
                setImgUrl(
                  'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/colors/autzu-color1.png'
                );
              }}></img>
            <img
              src={
                'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/colors/autzu-color2.png'
              }
              onClick={() => {
                toggleImg();
                setImgUrl(
                  'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/colors/autzu-color2.png'
                );
              }}></img>
            <img
              src={
                'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/colors/autzu-color3.png'
              }
              onClick={() => {
                toggleImg();
                setImgUrl(
                  'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/colors/autzu-color3.png'
                );
              }}></img>
            <img
              src={
                'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/colors/autzu-color4.png'
              }
              onClick={() => {
                toggleImg();
                setImgUrl(
                  'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/colors/autzu-color4.png'
                );
              }}></img>
            <img
              src={
                'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/colors/autzu-color5.png'
              }
              onClick={() => {
                toggleImg();
                setImgUrl(
                  'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/colors/autzu-color5.png'
                );
              }}
              style={{ border: '1px solid #dedede' }}></img>
            <img
              src={
                'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/colors/autzu-color6.png'
              }
              onClick={() => {
                toggleImg();
                setImgUrl(
                  'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/colors/autzu-color6.png'
                );
              }}></img>
            <img
              src={
                'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/colors/autzu-color7.png'
              }
              onClick={() => {
                toggleImg();
                setImgUrl(
                  'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/colors/autzu-color7.png'
                );
              }}></img>
          </div>
        </div>
        <div className="kitSection">
          <div className="sectionName">Graphics</div>
          <div className="sectionImages">
            <img
              src={graphic1}
              onClick={() => {
                toggleImg();
                setImgUrl(
                  'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/graphics/autzu-graphic1.png'
                );
              }}></img>
            <img
              src={graphic2}
              onClick={() => {
                toggleImg();
                setImgUrl(
                  'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/graphics/autzu-graphic2.png'
                );
              }}></img>
            <img
              src={graphic3}
              onClick={() => {
                toggleImg();
                setImgUrl(
                  'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/graphics/autzu-graphic3.png'
                );
              }}></img>
            <img
              src={graphic4}
              onClick={() => {
                toggleImg();
                setImgUrl(
                  'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/graphics/autzu-graphic4.png'
                );
              }}></img>
            <img
              src={graphic5}
              onClick={() => {
                toggleImg();
                setImgUrl(
                  'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/graphics/autzu-graphic5.png'
                );
              }}></img>
            <img
              src={graphic6}
              onClick={() => {
                toggleImg();
                setImgUrl(
                  'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/graphics/autzu-graphic6.png'
                );
              }}></img>
            <img
              src={graphic7}
              onClick={() => {
                toggleImg();
                setImgUrl(
                  'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/graphics/autzu-graphic7.png'
                );
              }}></img>
            <img
              src={graphic8}
              onClick={() => {
                toggleImg();
                setImgUrl(
                  'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/graphics/autzu-graphic8.png'
                );
              }}></img>
            <img
              src={graphic9}
              style={{ border: '1px solid #dedede' }}
              onClick={() => {
                toggleImg();
                setImgUrl(
                  'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/graphics/autzu-graphic9.png'
                );
              }}></img>
            <img
              src={graphic10}
              style={{ border: '1px solid #dedede' }}
              onClick={() => {
                toggleImg();
                setImgUrl(
                  'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/graphics/autzu-graphic10.png'
                );
              }}></img>
          </div>
        </div>
        <div className="kitSection">
          <div className="sectionName">Renders</div>
          <div className="sectionImages">
            <img
              src={renders1}
              onClick={() => {
                toggleImg();
                setImgUrl(
                  'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/renders/autzu-renders1.png'
                );
              }}
              style={{ border: '1px solid #dedede' }}></img>
            <img
              src={renders2}
              onClick={() => {
                toggleImg();
                setImgUrl(
                  'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/renders/autzu-renders2.png'
                );
              }}
              style={{ border: '1px solid #dedede' }}></img>
            <img
              src={renders3}
              onClick={() => {
                toggleImg();
                setImgUrl(
                  'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/renders/autzu-renders3.png'
                );
              }}
              style={{ border: '1px solid #dedede' }}></img>
            <img
              src={renders4}
              onClick={() => {
                toggleImg();
                setImgUrl(
                  'https://autzu-media-kit.s3.ca-central-1.amazonaws.com/renders/autzu-renders4.png'
                );
              }}
              style={{ border: '1px solid #dedede' }}></img>
          </div>
        </div>
        <div className="mediaText">
          <p>
            The materials provided in this media kit, including but not
            limited to logos, images, content, and other resources
            (collectively, "Materials"), are the property of Autzu Inc. and
            are protected by copyright, trademark, and other intellectual
            property laws.  {' '}
          </p>
          <p>
            Usage and Restrictions: The Materials are intended for use by
            journalists, media professionals, and partners of Autzu Inc.
            for the purpose of reporting, promoting, or discussing Autzu
            and its products or services. You may not modify, redistribute,
            or use the Materials for commercial purposes without the prior
            written consent of Autzu Inc. Any unauthorized use of the
            Materials is strictly prohibited.  
          </p>
          <p>
            Accuracy of Information: While Autzu Inc. strives to provide
            accurate and up-to-date information in its media kit, we make
            no representations or warranties regarding the accuracy,
            reliability, or completeness of the Materials. Autzu Inc. is
            not liable for any errors or omissions in the Materials, or for
            any actions taken based on the Materials.
          </p>
          <p>
            Updates and Revisions: Autzu Inc. reserves the right to update
            or revise the Materials at any time, without prior notice. We
            encourage users to regularly check for updates to ensure they
            are using the most current version of the Materials.{' '}
          </p>
          <p>
            Indemnification: By using the Materials, you agree to indemnify
            and hold harmless Autzu Inc., its officers, directors,
            employees, and agents from and against any and all claims,
            damages, losses, or expenses, including reasonable attorneys'
            fees, arising out of or in connection with your use of the
            Materials, your violation of this disclaimer, or your violation
            of any rights of any third party.
          </p>
          <p>
            If you have any questions about this disclaimer or need further
            information about using the Materials, please contact us at
            media@autzu.com
          </p>
        </div>
      </div>
      <FullImageModal isFull={isFull} imgUrl={imgUrl} />
      <TorontoFooter />
    </Fragment>
  );
};

export default MediaKit;



// WEBPACK FOOTER //
// ./src/components/Newsroom/MediaKit/index.js